import { render, staticRenderFns } from "./QuizConfigSettingModal.vue?vue&type=template&id=25cefdde&"
import script from "./QuizConfigSettingModal.vue?vue&type=script&lang=js&"
export * from "./QuizConfigSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizConfigSettingModal.vue?vue&type=style&index=0&id=25cefdde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports